import styled from 'styled-components'

export const SecondText = styled.p<{ textColor: string; size: number }>`
	color: ${(props) => props.textColor};
	font-size: ${(props) => props.size * 0.3 + 'px'};
	z-index: 1;
`

export const CircleSvg = styled.svg`
	position: 'absolute';
	top: 0;
	left: 0;
	width: '100%';
	height: '100%';
	transform: 'rotateY(-180deg) rotateZ(-90deg)';
	overflow: 'visible';
`

export const CountdownContainer = styled.div`
	display: 'flex';
	justify-content: 'center';
	align-items: 'center';
	position: 'relative';
	margin: 'auto';
	height: size;
	width: size;
	& svg {
	}
`
